import { useQuery } from '@tanstack/react-query';

import { personasByIdsQuery, type Persona } from '@/entities/persona';
import { useCurrentWorkspaceId } from '@/entities/workspace';

interface UseCorePersonasResult {
  personas: Persona[] | undefined;
  isLoading: boolean;
  /** True once loaded with at least one persona — i.e. Core Segments will render content. */
  hasPersonas: boolean;
}

/**
 * Shared persona fetch for the Audience Profiles Core Segments block. TanStack
 * Query dedupes the request, so the section and the block can both call this
 * without a second fetch — the section uses `hasPersonas` to decide whether the
 * block renders (and thus whether a following separator would orphan).
 */
export const useCorePersonas = (personaIds?: string[]): UseCorePersonasResult => {
  const workspaceId = useCurrentWorkspaceId();
  const { data: personas, isLoading } = useQuery(personasByIdsQuery(workspaceId, personaIds ?? []));

  return {
    personas,
    isLoading,
    hasPersonas: !isLoading && Boolean(personas?.length),
  };
};
